import { render, staticRenderFns } from "./EditQuantite.vue?vue&type=template&id=a9fce720"
import script from "./EditQuantite.vue?vue&type=script&lang=ts"
export * from "./EditQuantite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports